import React$1, { Component, forwardRef } from 'react';
import AnalyticsContext$1 from '../AnalyticsContext/AnalyticsContext.js';
import '../AnalyticsContext/index.js';
import { inheritsLoose as _inheritsLoose, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { getDisplayName } from '@emoney/kyber-helpers';
import PropTypes$1 from 'prop-types';

var propTypes = {
  analytics: PropTypes$1.shape({
    value: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.string), PropTypes$1.string]),
    actions: PropTypes$1.object
  }),
  forwardedRef: PropTypes$1.any
};
/**
 * withAnalytics HOC
 *
 * @param {typeof Component} WrappedComponent The component to wrap and enhance.
 * @return {Component} The wrapped component.
 */

function withAnalytics(WrappedComponent) {
  var ComponentWithAnalytics = /*#__PURE__*/function (_Component) {
    _inheritsLoose(ComponentWithAnalytics, _Component);

    function ComponentWithAnalytics() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;

      _defineProperty(_assertThisInitialized(_this), "handleTrack", function (eventProp, event, opts, action) {
        _this.props[eventProp] && _this.props[eventProp](event, opts);

        if (action) {
          var payload = action.payload;

          if (payload && typeof payload === 'object' && typeof payload.data === 'function') {
            action.payload.data = payload.data(event, opts);
          }
        }

        _this.context.track && _this.context.track(_this.props.analytics.value, action, event);
      });

      _defineProperty(_assertThisInitialized(_this), "mapEventHandlers", function () {
        var analytics = _this.props.analytics;

        if (analytics) {
          var actions = analytics.actions;

          if (analytics.value && !analytics.actions) {
            actions = WrappedComponent.defaultProps.analytics.actions;
          }

          return Object.keys(actions).reduce(function (handlers, prop) {
            handlers[prop] = function (event, opts) {
              return _this.handleTrack(prop, event, opts, actions[prop]);
            };

            return handlers;
          }, {});
        }

        return {};
      });

      return _this;
    }

    var _proto = ComponentWithAnalytics.prototype;

    _proto.render = function render() {
      var eventHandlers = this.mapEventHandlers();

      var _this$props = this.props,
          forwardedRef = _this$props.forwardedRef,
          restProps = _objectWithoutPropertiesLoose(_this$props, ["forwardedRef"]);

      return /*#__PURE__*/React$1.createElement(WrappedComponent, _extends({}, restProps, eventHandlers, {
        ref: forwardedRef
      }));
    };

    return ComponentWithAnalytics;
  }(Component);

  ComponentWithAnalytics.contextType = AnalyticsContext$1;
  ComponentWithAnalytics.defaultProps = WrappedComponent.defaultProps;
  ComponentWithAnalytics.displayName = "withAnalytics(" + getDisplayName(WrappedComponent) + ")";
  var ComponentWithForwardedRef = /*#__PURE__*/forwardRef(function (props, ref) {
    return /*#__PURE__*/React$1.createElement(ComponentWithAnalytics, _extends({}, props, {
      forwardedRef: ref
    }));
  });
  ComponentWithForwardedRef.propTypes = propTypes;
  ComponentWithForwardedRef.defaultProps = WrappedComponent.defaultProps;
  ComponentWithForwardedRef.displayName = "ForwardedRef(" + ComponentWithAnalytics.displayName + ")";
  return ComponentWithForwardedRef;
}

export default withAnalytics;
